import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Grid, 
  Paper, 
  Typography, 
  Button 
} from '@mui/material';
import { Link } from 'react-router-dom';
import { getBarbers } from '../../services/api';
import { Barber } from '../../types';

const BarberList: React.FC = () => {
  const [barbers, setBarbers] = useState<Barber[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBarbers = async () => {
      try {
        const data = await getBarbers();
        setBarbers(data);
      } catch (error) {
        console.error('Error fetching barbers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBarbers();
  }, []);

  if (loading) {
    return <Typography>Loading barbers...</Typography>;
  }

  return (
    <Container>
      <Typography variant="h4" gutterBottom sx={{ mt: 4 }}>
        Our Barbers
      </Typography>
      <Grid container spacing={3}>
        {barbers.map((barber) => (
          <Grid item xs={12} sm={6} md={4} key={barber.id}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6">{barber.name}</Typography>
              <Typography variant="body1">{barber.email}</Typography>
              <Button
                component={Link}
                to={`/barbers/${barber.id}`}
                variant="contained"
                fullWidth
                sx={{ mt: 2 }}
              >
                View Profile
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default BarberList; 